const messages = {
  deployment: { text: 'Waiting for an update', detail: 'Your request is saved. Work will start automatically after the update.', icon: 'clock', startupPhase: 'deployment' },
  service: { text: 'Waiting to start', detail: 'Your request is saved. Work will start automatically when the service is ready.', icon: 'clock', startupPhase: 'service' },
  preparing: { text: 'Getting the agent’s computer ready…', detail: 'Your request is saved. Getting its files and context ready.', icon: 'clock', isStarting: true },
  credits: { text: 'Waiting for credits', detail: 'Your request is saved. Work will start automatically when enough credits are available.', icon: 'coins', startupPhase: 'credits' },
  confirming: { text: 'Confirming start…', detail: 'Your request is saved. Checking whether Work has started.', icon: 'clock', isStarting: true, startupPhase: 'confirming' },
};
export function workLaunchWait(task) {
  if (task?.status !== 'queued' || task.launchQueue?.version !== 1
    || !['waiting', 'preparing', 'ready'].includes(task.launchQueue.phase)) return null;
  return messages[task.launchQueue.waitReason] || messages.service;
}

// Initial admission only moves forward. A delayed POST receipt or list response
// must not restore the initial queue after a newer response (including Stop).
export function isStaleWorkLaunchWait(previous, incoming) {
  return !!workLaunchWait(incoming) && previous?.launchQueue?.version === 1
    && ['running', 'idle', 'completed', 'stopped', 'failed', 'interrupted', 'budget_exceeded'].includes(previous.status);
}
